import type { QueryHookOptions } from "@apollo/client"
import { useQuery } from "@apollo/client"
import query from "@/v2-backoffice-client/license/create/license.create.seatCandidates.query.gql"
import type {
  LicenseSeatCandidatesQuery,
  LicenseSeatCandidatesQueryVariables,
} from "@/v2-backoffice-client/license/create/__types__/license.create.seatCandidates.query"

type Options = QueryHookOptions<
  LicenseSeatCandidatesQuery,
  LicenseSeatCandidatesQueryVariables
>

export function useLicenseSeatCandidatesQuery(options: Options) {
  return useQuery<
    LicenseSeatCandidatesQuery,
    LicenseSeatCandidatesQueryVariables
  >(query, options)
}
